/* @flow */

import * as React from 'react';
import scriptjs from 'scriptjs';

type Props = {
  children: React.Node,
  loader: React.ComponentType,
};

type State = {
  isPhaserReady: boolean,
};

class PhaserLoader extends React.Component<Props, State> {
  props: Props;

  state: State = {
    isPhaserReady: !!window.Phaser,
  };

  componentDidMount() {
    if (!window.Phaser) {
      scriptjs('/phaser.min.js', () => {
        this.setState({
          isPhaserReady: true,
        });
      });
    }
  }

  render() {
    const {
      children,
      loader: Loader,
    } = this.props;
    const { isPhaserReady } = this.state;

    return isPhaserReady ? children : <Loader />;
  }
}

export default PhaserLoader;
